import { Component, EventEmitter, Output, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuItem } from '@coin/admin/core/util';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { ViewInformationDialogComponent } from '../view-information/parts/view-information-dialog/view-information-dialog.component';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { PureFunctionPipe } from '@coin/shared/core/util-pipes';

@Component({
  selector: 'admin-app-card',
  templateUrl: './app-card.component.html',
  styleUrls: ['./app-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatCard,
    NgClass,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatCardContent,
    MatTooltip,
    MatCardActions,
    V2ButtonComponent,
    TranslatePipe,
    PureFunctionPipe
  ]
})
export class AppCardComponent {
  private readonly matDialog = inject(MatDialog);

  readonly menuItem = input<MenuItem>(undefined);
  readonly type = input<'primary' | 'secondary'>('primary');
  readonly translationPrefix = input<string>(undefined);
  readonly showMoreInfoButton = input(false);

  @Output() openClicked: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  public get isPrimary(): boolean {
    return this.type() === 'primary';
  }

  public camelCaseToKebabCase = TinyHelpers.camelCaseToKebabCase;

  public openInformationDialog(item: MenuItem): void {
    this.matDialog.open(ViewInformationDialogComponent, {
      width: '50vw',
      maxWidth: '2000px',
      data: { translationPrefix: `${this.translationPrefix()}${this.camelCaseToKebabCase(item.name)}.` }
    });
  }

  public isTruncated(element: HTMLElement): boolean {
    return element?.offsetWidth < element?.scrollWidth || element?.offsetHeight < element?.scrollHeight;
  }
}
